/** @format */

import { defaultActions } from '../../core/actionsDefault';
import { reducerDebug } from '../../core/debug';

export const operationOnSimcardConstants = {
    SIM_CARD_ACTIVATE_PUT: 'sim_card_activate_put',
    SIM_CARD_CANCEL_ACTIVATION: 'sim_card_cancel_activation',
    SIM_CARD_CHANGE_CALL_EXPIRY: 'SIM_CARD_CHANGE_CALL_EXPIRY',
};

export class operationOnSimcardActions extends defaultActions {}

export function operationOnSimcardReducers(state = {}, action) {
    reducerDebug('operationOnSimcard reducer: ' + action.type);
    switch (action.type) {
        case operationOnSimcardConstants.SIM_CARD_ACTIVATE_PUT:
        case operationOnSimcardConstants.SIM_CARD_CANCEL_ACTIVATION:
        case operationOnSimcardConstants.SIM_CARD_CHANGE_CALL_EXPIRY:
            return {
                response: action.data,
                type: action.type,
            };
        default:
            return {
                type: null,
                response: null,
            };
    }
}
